import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import PrivateRoute from "./utils/auth/PrivateRoute";
import AdminRoute from "./utils/auth/AdminRoute";
import Profile from "./pages/Dashboard/User/Profile";
import UserDashboard from "./pages/Dashboard/User/UserDashboard";
import NotificationsPage from "./pages/Dashboard/User/Notifications/NotificationsPage";
import AddressManagementPage from "./pages/Dashboard/User/Address/AddressManagementPage";

import {
  Home,
  Signin,
  Signup,
  VerifyOtp,
  NotFound,
  ProductPage,
  AdminOrders,
  Cart,
  Wishlist,
  UserOrders,
  UserOffers,
  PageWrapper,
  CategoryProductsPage,
  SearchResults,
  PrivacyPolicy,
  About,
  AdminDashboard,
  Categories,
  Products,
  Offers,
  UserManagement,
  AdminUserProfile,
  BundleManagement,
  Announcements,
  Coupons,
  ForgetPassword,
  ResetPassword,
  AbandonedWishlist,
  Contacts,
  Shipping,
  SupportTickets,
} from "./pages";

const Routes = () => {
  return (
    <BrowserRouter>
      <PageWrapper>
        <Switch>
          <Route path="/signup" exact component={Signup} />
          <Route path="/about" exact component={About} />
          <Route path="/verify-otp" exact component={VerifyOtp} />
          <Route path="/signin" exact component={Signin} />
          <Route path="/forget-password" exact component={ForgetPassword} />
          <Route path="/reset-password" exact component={ResetPassword} />
          <Route path="/" exact component={Home} />
          <Route path="/search" exact component={SearchResults} />
          <Route path="/privacy-policy" exact component={PrivacyPolicy} />
          <Route
            path="/category/:categoryId/products"
            exact
            component={CategoryProductsPage}
          />

          <Route path="/wishlist" exact component={Wishlist} />
          <Route path="/cart" exact component={Cart} />
          <Route path="/product/:productId" exact component={ProductPage} />

          {/* DONE */}
          {/* PRIVATE ROUTES */}
          <PrivateRoute
            path="/user/dashboard"
            exact
            component={UserDashboard}
          />
          <PrivateRoute
            path="/user/dashboard/orders/"
            exact
            component={UserOrders}
          />

          <PrivateRoute
            path={"/user/dashboard/wishlist"}
            exact
            component={Wishlist}
          />
          <PrivateRoute path="/user/dashboard/cart" exact component={Cart} />
          <PrivateRoute
            path={"/user/dashboard/offers"}
            exact
            component={UserOffers}
          />
          <PrivateRoute
            path="/user/dashboard/notifications"
            exact
            component={NotificationsPage}
          />
          <PrivateRoute
            path="/user/dashboard/addresses"
            exact
            component={AddressManagementPage}
          />

          <PrivateRoute
            path="/user/dashboard/profile"
            exact
            component={Profile}
          />

          {/* ADMIN DASHBOARD */}
          <AdminRoute
            path="/admin/dashboard"
            exact
            component={AdminDashboard}
          />
          {/* Consolidated Admin Routes */}
          <AdminRoute path="/admin/categories" exact component={Categories} />
          <AdminRoute path="/admin/products" exact component={Products} />
          <AdminRoute path="/admin/offers" exact component={Offers} />
          <AdminRoute path="/admin/users" exact component={UserManagement} />
          <AdminRoute
            path="/admin/users/:userId"
            exact
            component={AdminUserProfile}
          />
          <AdminRoute path="/admin/bundle" exact component={BundleManagement} />

          <AdminRoute path="/admin/orders" exact component={AdminOrders} />
          {/* <AdminRoute
            path="/admin/orders/:orderId"
            exact
            component={AdminProductOrders}
          /> */}
          <AdminRoute path="/admin/coupons" exact component={Coupons} />
          <AdminRoute path="/admin/contacts" exact component={Contacts} />
          {/* Legacy routes for backward compatibility */}

          {/* <AdminRoute path="/create/offer" exact component={CreateOffer} />
          <AdminRoute path="/manage/offers" exact component={ManageOffers} /> */}

          {/* <AdminRoute
            path="/admin/update/offer/:offerId"
            exact
            component={UpdateOfferPage}
          /> */}
          <AdminRoute
            path="/admin/announcements"
            exact
            component={Announcements}
          />
          {/* <AdminRoute path="/admin/contact" exact component={ContactMgmt} /> */}
          <AdminRoute
            path="/admin/abandoned-wishlist"
            exact
            component={AbandonedWishlist}
          />
          <AdminRoute path="/admin/shipping" exact component={Shipping} />
          <AdminRoute
            path="/admin/support-tickets"
            exact
            component={SupportTickets}
          />
          <Route path="/*" exact component={NotFound} />
        </Switch>
      </PageWrapper>
    </BrowserRouter>
  );
};

export default Routes;
